/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef} from '@angular/core';
import * as _ from 'lodash';
import {ADN_TARGETING_TYPES} from '../targeting/targeting-constants';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';

export function resetDimensionsBasedOnAdUnitOption(model: any): void {
  if (model.adUnitOption === 'RANGE') {
    model.dimensions = null;
  } else {
    model.minWidth = null;
    model.minHeight = null;
    model.height = null;
    model.width = null;
  }
}

export interface AdUnitCommonsHost {
  timeZones?: any[];
  specifyTimeZone?: boolean;
  timeZoneChange?: () => void;
  targetingTypes?: any[];
  cdr?: ChangeDetectorRef;
}

export function createAdUnitCommons(
  ctrl: AdUnitCommonsHost,
  timezonesResource: any,
  LocalNetworkProfile: any,
  param = 'model',
  modelHolder?: any
): {
  setTimezones: () => void;
  setTimezoneChange: () => void;
  setTargetingTypes: () => void;
  getBeforeSubmitTimeZoneValue: () => string | null;
} {
  const getModel = () => modelHolder || (ctrl as any)[param];

  return {
    setTimezones(): void {
      if (!ctrl.timeZones) {
        timezonesResource.get().then((timeZones: any[]) => {
          const applyTimezones = () => {
            ctrl.timeZones = timeZones;
            ctrl.specifyTimeZone = !!getModel()?.timeZone;
          };
          // undefined → [] flips [resolved] on adn-promise-spinner; defer to avoid NG0100.
          if (ctrl.cdr) {
            deferMarkForCheck(ctrl.cdr, applyTimezones);
          } else {
            applyTimezones();
          }
        });
      }
    },
    setTimezoneChange(): void {
      ctrl.timeZoneChange = () => {
        const model = getModel();
        if (ctrl.specifyTimeZone) {
          model.timeZone = model.timeZone || LocalNetworkProfile.get('timeZone');
        } else {
          model.timeZone = null;
        }
      };
    },
    setTargetingTypes(): void {
      ctrl.targetingTypes = _.map(ADN_TARGETING_TYPES, (val) => val);
    },
    getBeforeSubmitTimeZoneValue(): string | null {
      return ctrl.specifyTimeZone ? getModel()?.timeZone : null;
    }
  };
}
